export default {
  isIe() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE "); // IE 10 or older
    const trident = ua.indexOf("Trident/"); //IE 11
    return msie > 0 || trident > 0;
  },
  loadScript(url) {
    if (!window.wpLoadedScripts) {
      window.wpLoadedScripts = [];
    }
    if (!window.wpLoadedScripts.includes(url)) {
      window.wpLoadedScripts.push(url);
      return new Promise((resolve, reject) => {
        const loadingScript = document.createElement("script");
        loadingScript.src = url;
        loadingScript.onload = () => resolve();
        loadingScript.onerror = () => reject();
        document.body.appendChild(loadingScript);
      });
    }
  },
};
